function Editorial({ title, subtitle }) {
  return (
    <div className='article editorial'>
      <div className='container'>
        <h2>
          <div className='subtitle'>{subtitle}</div>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          {/* <span dangerouslySetInnerHTML={{ __html: title }} /> */}
        </h2>
        <div className='content'>
          <p>Political problems were undoubtedly the trigger for running for many people. More and more people are being squeezed by ever-widening structural problems. The harshly enforced lockdowns, quarantine camps and mass compulsory testing of the zero-COVID policy in particular led people to despair of unscientific, arbitrary and authoritarian controls under Xi. Individuals in totalitarian societies are often isolated, with limited and costly options for resistance, with escape often the only rational choice people have left.</p>
          <p>Running doesn’t mark the end of the problem, but the start of new ways of dealing with it. It’s a complex process of reinvention that works from the bottom up, requiring new immigrants to deal with their own basic need for survival alongside the formation of new values and community identities.</p>
          <p>In recent years, younger people who are well educated in the humanities have begun to get more political, participating more and more in public events. They are also developing their own sense of identity when it comes to putting down roots overseas.</p>
          <a
            href="https://www.wainao.me/wainao-reads/run-passive-resistance-social-movement-en-07012023"
            target='_blank'
            rel="noreferrer" >Read more</a>
        </div>
      </div>
    </div>
  );
}

export default Editorial;
